<template>
  <div class="container">
    <div class="product-wrap">
      <div class="compInfo">
        <div class="logo__box">
          <img src="../assets/images/htlogo-b.svg" alt="" />
        </div>
        <div class="conts__box">
          <dl>
            <dd>
              모션에 특화된 제품을 고객의 니즈에 맞추어 고객에게<br />
              차별화된 솔루션을 제공합니다.
            </dd>
            <!-- <dt>
              PARTNERS
            </dt> -->
          </dl>
        </div>

        <div class="logo__slide">
          <ul class="logo_slide_bx">
            <li v-for="(logo, index) in this.companyList" :key="index">
              <img
                :src="logo"
                alt=""
                @error="this.replaceByDefault($event, 'logo')"
              />
            </li>
          </ul>
          <ul class="logo_slide_bx">
            <li v-for="(logo, index) in this.companyList" :key="index">
              <img
                :src="logo"
                alt=""
                @error="this.replaceByDefault($event, 'logo')"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// url 공통화
import axios from "axios";
import {
  DEF_EMPTY_LOGO_IMG_PATH,
  DEF_EMPTY_PRD_IMG_PATH,
  resolveAssetPath,
} from "../consts/consts";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});
export default {
  data() {
    return {
      companyList: [],
    };
  },
  methods: {
    /*
        onerror 이미지 대체 함수
     */
    replaceByDefault(e, type) {
      if (type === "logo") e.target.src = DEF_EMPTY_LOGO_IMG_PATH;
      if (type === "product") e.target.src = DEF_EMPTY_PRD_IMG_PATH;
    },
    getCompanyList() {
      instance
        .get(`/api/tech/v1.0/company/list`, {
          headers: {
            "x-api-key": `${process.env.VUE_APP_API_KEY || "YsD4oLqC2MgBzP1x"}`, // 여기에 API 키 값을 넣어주세요
          },
        })
        .then((res) => {
          if (res.data.code === "200") {
            const result = res.data.results;
            /* 간격조절을 위해 2번씩 저장 */
            result.forEach((company) => {
              if (
                company.companyDarkImagePath &&
                company.companyDarkImagePath !== ""
              ) {
                this.companyList.push(resolveAssetPath(company.companyDarkImagePath));
              } else {
                this.companyList.push(DEF_EMPTY_LOGO_IMG_PATH);
              }
            });
            result.forEach((company) => {
              if (
                company.companyDarkImagePath &&
                company.companyDarkImagePath !== ""
              ) {
                this.companyList.push(resolveAssetPath(company.companyDarkImagePath));
              } else {
                this.companyList.push(DEF_EMPTY_LOGO_IMG_PATH);
              }
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            // 요청은 성공했지만 서버가 2xx 이외의 상태 코드로 응답한 경우.
            console.log("서버 응답 상태 코드:", error.response.status);
            console.log("응답 데이터:", error.response.data); // 응답 데이터에서 오류 세부 정보 확인
          } else if (error.request) {
            // 요청은 성공했지만 응답을 받지 못한 경우.
            console.log("서버로부터 응답을 받지 못했습니다.");
          } else {
            // 요청 설정 중 오류가 발생한 경우.
            console.log("오류:", error.message);
          }
        });
    },
  },
  created() {
    this.getCompanyList();
  },
};
</script>

<style></style>
